import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router';

import { useAuth } from '../contexts/AuthContext';

/**
 * Ponto de chegada do login social (PRD 33.5).
 *
 * O backend já criou a sessão (cookie httpOnly) antes de redirecionar pra
 * cá — esta tela só precisa reconsultar `/auth/me` para o resto da aplicação
 * saber que alguém entrou, e então seguir para a turma (se o login também
 * matriculou) ou para a home.
 */
export default function OAuthCallbackPage() {
  const [params] = useSearchParams();
  const { user, loading, refresh } = useAuth();
  const navigate = useNavigate();
  const [refreshed, setRefreshed] = useState(false);

  const error = params.get('error');
  const classId = params.get('classId');

  useEffect(() => {
    if (error) return;
    void refresh().then(() => setRefreshed(true));
  }, [error, refresh]);

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <p className="eyebrow">Login social</p>
          <h1>Não foi possível entrar</h1>
          <p className="form-error" role="alert">
            {error}
          </p>
          <button type="button" className="primary" onClick={() => void navigate('/login')}>
            Voltar
          </button>
        </div>
      </div>
    );
  }

  if (loading || !refreshed) {
    return (
      <div className="centered-state">
        <p>Entrando…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={classId ? `/turmas/${classId}` : '/'} replace />;
}
